// POST
export const ENDPOINTS_POST = {
	// register
	POST_REGISTER: "/customers/register",

	// treatments
	POST_TREATMENTS: "/treatments",

	// products
	POST_PRODUCTS: "/products",

	// bundles
	POST_BUNDLE: "/bundles",

	// authenticate
	POST_AUTHENTICATE: "/authentication/admin",

	// users
	POST_ADMIN_USER: "/users/admin",

	// notification
	POST_NOTIFICATION: "/notification",

	// brands
	POST_BRANDS: "/brands",

	// dog bundles
	POST_DOG_BUNDLE: "/dog-bundles",

	// breeds
	POST_BREEDS: "/breeds",

	//breeder
	POST_BREEDERS: "/breeders",

	// multiple products
	POST_MULTIPLE_PRODUCTS: "/multiple/products",

	// Dam/Sire Documents
	POST_DAM_SIRE_DOCUMENT: "/admin/dam-sire/documents",
}

// PUT
export const ENDPOINTS_PUT = {
	// treatments
	PUT_TREATMENT: "/treatment-schedule",

	// notifications
	PUT_NOTIFICATION: "/notification",

	PUT_ALL_NOTIFICATIONS: "/notifications/admin",

	// products
	PUT_PRODUCT: "/product",

	// bundles
	PUT_BUNDLE: "/bundle",

	// tracking
	PUT_TRACKING: "/track",

	// social club
	PUT_REPORT_CONTENT: "/report",
	PUT_CLUB: "/club",

	// user
	PUT_USER: "/user",

	// pet
	PUT_PET: "/pet",

	// order
	PUT_ORDER_TRACKING_NUMBER: "/order/tracking-number",
	PUT_CANCEL_ORDER: "/order",
	PUT_UPDATE_ORDER_STATUS: "/order",

	// brands
	PUT_BRANDS: "/brands",

	// pet orders
	PUT_PET_ORDERS: "/pet-orders",

	// dog bundles
	PUT_DOG_BUNDLE: "/dog-bundle",

	// payment latitude
	PUT_PAYMENT: "/payment/lattitude",
	PUT_PROCESS_PAYMENT: "/payment/latitude",

	// notification
	PUT_ADMIN_NOTIFICATION: "/admin/notification",

	// breeds
	PUT_BREEDS: "/breeds",

	// store credit
	PUT_STORE_CREDIT: "/store-credit",

	//dog purchase
	PUT_DOG_PURCHASE: "/dog-purchase",

	//breeder
	PUT_BREEDER: "/breeders",

	//puppy sell
	PUT_PUPPY_SELL: "/puppy-sell",

	//Latitude Interest Free
	PUT_REFUND_PRODUCT_LATITUDE_INTEREST_FREE: "/latitude-interest-free",
	PUT_PROCESS_LATITUDE_INTEREST_FREE: "/latitude-interest-free",
	
	// subscription
	PUT_SUBSCRIPTION: "/subscription",

	//DAM SIRE
	PUT_DAM_SIRE: "admin/dam-sire",
	PUT_DAM_SIRE_DOCUMENT: "/admin/dam-sire/documents",

	// Ovulation / Gestation
	GET_OVULATION_GESTATION: "admin/ovulation-gestation",
}

// GET
export const ENDPOINTS_GET = {
	// breeds
	GET_BREEDS: "/breeds",
	GET_BREEDS_MANAGEMENT: "/breeds-management",

	// user
	GET_USER_BY_ID: "/user",
	GET_USER: "/users",
	
	// store credit history
	GET_USER_STORE_CREDIT_HISTORY: "/admin/user/store-credit-history",

	// general info
	GET_BREED_INFO: "/breed/info",

	// treatments
	GET_TREATMENTS: "/treatments",
	GET_TREATMENT_SCHEDULE: "/treatment-schedule",
	GET_TREATMENTS_FREQUENCY: "/treatment/frequency-code",

	// notifications
	GET_NOTIFICATION: "/notifications",
	GET_NOTIFICATION_BY_ID: "notification/admin",
	GET_NOTIFICATION_LIST: "/notification/list",
	GET_ADMIN_NOTIFICATION: "/admin/notification",

	// Bundles
	GET_BUNDLES: "/bundles",
	GET_BUNDLES_BY_ID: "/bundle",
	GET_BUNDLE_CHECK: "/bundle-check/name",

	// brands
	GET_BRANDS: "/brands",

	// tracking
	GET_TRACKING: "/track/history",

	// products
	GET_PRODUCT: "/product",
	GET_PRODUCTS: "/products",
	GET_PRODUCT_TYPE: "/product-types",

	// subscription
	GET_SUBSCRIPTION: "/subscription",
	GET_SUBSCRIPTION_PERIOD: "/subscription/period",
	GET_SUBSCRIPTION_LIST: "/subscription/list",

	// pets
	GET_PETS: "/pets",

	// post
	GET_POSTS: "/posts",

	// Comment
	GET_COMMENTS: "/comments",

	// audit trail
	GET_AUDIT_TRAIL_LIST: "/audit-log/trail",
	GET_AUDIT_TRAIL_ACTION_LIST: "/audit-log/actions",
	GET_AUDIT_TRAIL_CHANGES: "/audit-log",

	// social club
	GET_CLUB_MEMBERS: "/clubs/member",
	GET_GROUPS: "/groups",
	GET_ADMIN_REPORTED: "/report",

	// orders
	GET_ORDER: "/order",
	GET_FOR_DELIVERY: "/for-delivery",

	// reaction
	GET_REACTION: "/reactions",

	// customer
	GET_CUSTOMER: "/customers",

	// pet orders
	GET_PET_ORDERS: "/pet-orders",

	//dog purchase
	GET_DOG_PURCHASE: "/dog-purchase",

	//puppy-sell
	GET_PUPPY_SELL: "/puppy-sell",

	//breeder
	GET_BREEDER: "/breeders",

	// suppliers
	GET_SUPPLIERS_LIST: "/suppliers/list",

	//DAM SIRE
	GET_DAM_SIRE: "admin/dam-sire",

	GET_USER_NOTES_AND_REMINDERS: "/admin/user",
}

// DELETE
export const ENDPOINTS_DELETE = {
	// treatments
	DELETE_TREATMENT: "/treatment",

	// products
	DELETE_PRODUCT: "/product",
	DELETE_BUNDLE: "/bundle",

	// tracking
	DELETE_TRACKING: "/track",

	// Post
	DELETE_POST: "/posts",

	// Comment
	DELETE_COMMENT: "/comments",

	// subscriptions
	DELETE_SUBSCRIPTION: "/subscription",

	// notifications
	DELETE_NOTIFICATION: "/notification",

	// breeds
	DELETE_BREED: "/breeds",

	// brands
	DELETE_BRAND: "/brands",

	// breeder
	DELETE_BREEDER: "/breeder/delete",

	//DAM SIRE
	DELETE_DAM_SIRE_DOCUMENT: "/admin/dam-sire/documents",
}
